export default __webpack_public_path__ + "static/media/sc-mp-ico.5ec85e85.svg";